import { useEffect, useState } from "react";
import { useYjsAwareness, useYjsStatus } from "../state/yjs-provider";

/**
 * Connection status indicator component.
 * Displays sync status and peer count in the header.
 */
export function ConnectionStatus() {
  const status = useYjsStatus();
  const awareness = useYjsAwareness();
  const [userCount, setUserCount] = useState(1);

  useEffect(() => {
    if (!awareness) return;

    const updateUserCount = () => {
      const states = awareness.getStates();
      // Filter out null states (disconnected clients)
      const activeUsers = Array.from(states.values()).filter(
        (state: any) => state?.user,
      );
      setUserCount(activeUsers.length);
    };

    // Initial count
    updateUserCount();

    // Listen for awareness changes
    awareness.on("change", updateUserCount);

    return () => {
      awareness.off("change", updateUserCount);
    };
  }, [awareness]);

  const getStatusConfig = () => {
    switch (status) {
      case "connected":
        return {
          label: "Live",
          color: "bg-green-500",
          textColor: "text-green-400",
        };
      case "connecting":
        return {
          label: "Connecting...",
          color: "bg-yellow-500",
          textColor: "text-yellow-400",
        };
      case "connected-local":
        return {
          label: "Local",
          color: "bg-blue-500",
          textColor: "text-blue-400",
        };
      default:
        return {
          label: "Offline",
          color: "bg-gray-500",
          textColor: "text-gray-400",
        };
    }
  };

  const config = getStatusConfig();

  return (
    <div className="pointer-events-auto flex items-center gap-2 bg-black/40 backdrop-blur-sm border border-white/10 rounded px-2 py-1 text-white text-xs">
      {/* Status dot */}
      <div className={`w-2 h-2 rounded-full ${config.color}`} />

      {/* Status text */}
      <span className={config.textColor}>{config.label}</span>

      {/* User count (only show when connected or connecting) */}
      {(status === "connected" || status === "connecting") && (
        <span className="opacity-60">
          {userCount} {userCount === 1 ? "user" : "users"}
        </span>
      )}
    </div>
  );
}
